import { gql } from '@apollo/client';

import USER_FRAGMENT from '../fragments/user';
import CLASSROOM_FRAGMENT from 'graph/fragments/classroom';
import CLASSROOM_STATS_FRAGMENT from 'graph/fragments/classroom-stats';

export default gql`
  query getUserInformation($where: UserWhereInput!) {
    user(where: $where) {
      ...BaseUser
      licenseUsage {
        assignedCount
        product {
          id
          iconUrl
          name
        }
      }
      classroomEnrollments {
        classroom {
          ...BaseClassroom
          licenseUsage {
            assignedCount
            product {
              id
              iconUrl
            }
            productCurriculum {
              id
              iconUrl
            }
          }
          stats {
            ...BaseClassroomStats
          }
        }
      }
      organizationAssociations {
        organization {
          id
          name
        }
        organizationRoles {
          id
          name
          displayName
          public
        }
      }
    }
  }
  ${USER_FRAGMENT}
  ${CLASSROOM_FRAGMENT}
  ${CLASSROOM_STATS_FRAGMENT}
`;
